function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(7.2063e-17,-1.17688,1.17688,7.2063e-17,-3.70393,76.6429)"
}, React.createElement("path", {
  d: "M52.573,7.555C52.335,7.213 51.945,7.01 51.529,7.01C51.112,7.01 50.722,7.213 50.484,7.555L38.665,24.47C38.393,24.86 38.36,25.368 38.579,25.789C38.799,26.211 39.235,26.475 39.71,26.475L63.348,26.475C63.823,26.475 64.258,26.211 64.478,25.789C64.697,25.368 64.664,24.86 64.392,24.47L52.573,7.555Z"
}));
var SvgBackFilled = function SvgBackFilled(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-filled.f1ee9a42.svg";
export { ForwardRef as ReactComponent };